import React from 'react';
import { Line, Svg } from 'react-native-svg';
import type { IconProps } from './types';

// Italic "I" glyph for the message text-styles toolbar (not a Figma icon
// export; drawn to match the 24-viewBox stroke icons in this set).
export const ItalicIcon: React.FC<IconProps> = ({
  size = 24,
  color = '#020202',
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    overflow="visible"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Line x1="19" y1="4" x2="10" y2="4" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <Line x1="14" y1="20" x2="5" y2="20" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <Line x1="15" y1="4" x2="9" y2="20" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </Svg>
);

ItalicIcon.displayName = 'ItalicIcon';
